module.exports = __webpack_public_path__ + "img/illustration-passionate.c897be63.svg";